import { create } from 'zustand';
import { ApiUtils, CardApi, CardEntity, RequestStrategyEnum } from '@shared/api';

interface ICardsByAccountStore {
  loading: boolean;
  error: string | null;
  cards: CardEntity[];
  getCardsByAccount: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCardsByAccountStore = create<ICardsByAccountStore>((set) => ({
  loading: false,
  error: null,
  cards: [],

  getCardsByAccount: ApiUtils.wrapperApi(async (accountId: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.getCardsByAccount(accountId, signal);
      set({ cards: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ cards: [], loading: false, error: null }),
}));
